interface IError {
  error: string;
  password: string;
  email: string;
}

export const errorStrings = {
  error: 'auth_common_network_error',
  password: 'auth_password_error',
  email: 'auth_email_error',
};

export function getErrorTransKey(key: string): string {
  return errorStrings[key as keyof IError];
}
